(() => {
  // A PDP or Theme Editor may load more than one recommendation section.
  if (window.QuadroEUCollection) {
    window.QuadroEUCollection.init(document);
    return;
  }
  const moneyFormatter = (currency) => {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || "de", {
        style: "currency",
        currency: currency || "CNY"
      });
    } catch (error) {
      return null;
    }
  };

  const formatMoney = (cents, currency) => {
    const formatter = moneyFormatter(currency);
    if (formatter) return formatter.format((cents || 0) / 100);
    return `${((cents || 0) / 100).toFixed(2)} ${currency || ""}`.trim();
  };

  const escapeHtml = (value) => String(value || "").replace(/[&<>"']/g, (character) => ({
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&#039;"
  }[character]));

  const formatMeasurementHtml = (value) => escapeHtml(value)
    .replace(/m2/gi, "m<sup>2</sup>")
    .replace(/m²/gi, "m<sup>2</sup>");

  const setupProductVariants = (scope = document) => {
    const roots = [...(scope.matches?.('[data-eu-collection-product]') ? [scope] : []), ...scope.querySelectorAll('[data-eu-collection-product]')];
    roots.forEach((root) => {
      if (root.dataset.euVariantBound) return;
      root.dataset.euVariantBound = "true";
      const select = root.querySelector("[data-variant-select]");
      const data = root.querySelector("[data-product-variants]");
      let image = root.querySelector("[data-product-image]");
      const lightboxTrigger = root.querySelector("[data-product-root-gallery-trigger]");
      const gallerySlides = Array.from(root.querySelectorAll("[data-product-gallery-slide]"));
      const galleryThumbs = Array.from(root.querySelectorAll("[data-product-gallery-thumb]"));
      const sku = root.querySelector("[data-variant-sku]");
      const skuRow = root.querySelector("[data-variant-sku-row]");
      const includedSku = root.querySelector("[data-variant-included-sku]");
      const includedSkuWrap = root.querySelector("[data-variant-included-sku-wrap]");
      const barcode = root.querySelector("[data-variant-barcode]");
      const barcodeRow = root.querySelector("[data-variant-barcode-row]");
      const variantTitle = root.querySelector("[data-variant-title]");
      const variantTitleRow = root.querySelector("[data-variant-title-row]");
      const dimension = root.querySelector("[data-variant-dimension]");
      const dimensionRow = root.querySelector("[data-variant-dimension-row]");
      const platform = root.querySelector("[data-variant-platform]");
      const platformRow = root.querySelector("[data-variant-platform-row]");
      const price = root.querySelector("[data-product-price]");
      const button = root.querySelector("[data-add-to-cart-button]");
      const backInStock = root.querySelector("[data-back-in-stock]");
      const swatches = Array.from(root.querySelectorAll("[data-variant-swatch]"));
      const links = Array.from(root.querySelectorAll("[data-product-link]"));

      if (!select || !data || !button) return;

      let variants = [];
      try {
        variants = JSON.parse(data.textContent);
      } catch (error) {
        variants = [];
      }

      if (root.dataset.randomVariant === "true" && variants.length > 1) {
        const availableVariants = variants.filter((variant) => variant.available);
        const variantPool = availableVariants.length > 0 ? availableVariants : variants;
        const randomVariant = variantPool[Math.floor(Math.random() * variantPool.length)];
        if (randomVariant) select.value = String(randomVariant.id);
      }


      const initialVariant = variants.find(item => String(item.id) === String(select.value));
      if (!image) {
        if (window.QuadroProductMedia) image = window.QuadroProductMedia.mount(root, initialVariant);
        else {
          const template = root.querySelector('template[data-quadro-card-image]');
          const source = template?.content?.querySelector('[data-product-image]');
          if (source) {
            image = source.cloneNode(true);
            // Keep the randomized image correct even if the shared asset failed.
            if (initialVariant?.image) {
              image.removeAttribute('srcset');
              image.src = initialVariant.image;
              image.alt = initialVariant.imageAlt || '';
            }
            template.replaceWith(image);
          }
        }
      }
      const setActiveGalleryImage = (imageId) => {
        if (!imageId || gallerySlides.length === 0) return false;
        const targetId = String(imageId);
        const activeSlide = gallerySlides.find((slide) => String(slide.dataset.productMediaImageId) === targetId);
        if (!activeSlide) return false;

        gallerySlides.forEach((slide) => {
          const isActive = slide === activeSlide;
          slide.classList.toggle("is-active", isActive);
          slide.hidden = !isActive;
        });

        galleryThumbs.forEach((thumb) => {
          const isActive = String(thumb.dataset.productMediaImageId) === targetId;
          thumb.classList.toggle("is-active", isActive);
          thumb.setAttribute("aria-current", isActive ? "true" : "false");
        });

        return true;
      };

      galleryThumbs.forEach((thumb) => {
        thumb.addEventListener("click", () => {
          setActiveGalleryImage(thumb.dataset.productMediaImageId);
        });
      });

      const updateVariant = () => {
        const variant = variants.find((item) => String(item.id) === String(select.value));
        if (!variant) return;

        const galleryUpdated = variant.imageId && setActiveGalleryImage(variant.imageId);
        if (!galleryUpdated && image && variant.image) {
          if (window.QuadroProductMedia) window.QuadroProductMedia.update(image, variant);
          else {
            image.removeAttribute('srcset');
            if (image.getAttribute('src') !== variant.image) image.src = variant.image;
            image.alt = variant.imageAlt || "";
          }
        }

        if (lightboxTrigger && variant.imageFull) {
          lightboxTrigger.dataset.lightboxSrc = variant.imageFull;
          lightboxTrigger.dataset.lightboxThumb = variant.imageThumb || variant.imageFull;
          lightboxTrigger.dataset.lightboxAlt = variant.imageAlt || "";
        }

        if (sku) {
          sku.textContent = variant.sku || sku.dataset.empty;
          if (skuRow) skuRow.hidden = !variant.sku;
        }

        if (includedSku) {
          includedSku.textContent = variant.sku || "";
          if (includedSkuWrap) includedSkuWrap.hidden = !variant.sku;
        }


        if (barcode) {
          barcode.textContent = variant.barcode || barcode.dataset.empty;
          if (barcodeRow) barcodeRow.hidden = !variant.barcode;
        }

        if (variantTitle) {
          const title = variant.title === "Default Title" ? "" : variant.title;
          variantTitle.textContent = title;
          if (variantTitleRow) variantTitleRow.hidden = !title;
        }

        if (dimension) {
          dimension.innerHTML = formatMeasurementHtml(variant.dimension || "");
          if (dimensionRow) dimensionRow.hidden = !variant.dimension;
        }

        if (platform) {
          platform.innerHTML = formatMeasurementHtml(variant.platform || "");
          if (platformRow) platformRow.hidden = !variant.platform;
        }

        if (price) {
          price.textContent = variant.price;
        }

        button.disabled = !variant.available;
        const buttonText = variant.available ? button.dataset.addText : button.dataset.soldOutText;
        const buttonLabel = button.querySelector('[data-add-to-cart-label]');
        if (buttonLabel) {
          buttonLabel.textContent = buttonText;
          button.title = buttonText;
        } else button.textContent = buttonText;
        const availability = root.querySelector('[data-variant-availability]');
        if (availability) availability.hidden = variant.available;
        if (backInStock) backInStock.dataset.variantId = String(variant.id);

        links.forEach((link) => {
          try {
            const url = new URL(link.href, window.location.origin);
            url.searchParams.set("variant", variant.id);
            link.href = `${url.pathname}${url.search}${url.hash}`;
          } catch (error) {
            return;
          }
        });

        swatches.forEach((swatch) => {
          const isActive = String(swatch.dataset.variantId) === String(variant.id);
          swatch.classList.toggle("is-active", isActive);
          swatch.setAttribute("aria-pressed", isActive ? "true" : "false");
        });
      };

      select.addEventListener("change", updateVariant);
      swatches.forEach((swatch) => {
        swatch.addEventListener("click", () => {
          select.value = swatch.dataset.variantId;
          select.dispatchEvent(new Event("change", { bubbles: true }));
        });
      });
      updateVariant();
    });
  };


  window.QuadroEUCollection = { init: setupProductVariants };
  const startCollectionCards = () => setupProductVariants();
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", startCollectionCards, { once: true });
  } else {
    startCollectionCards();
  }
  document.addEventListener('shopify:section:load', event => setupProductVariants(event.target));
  document.querySelectorAll('[data-quadro-native-collection]').forEach(collection => {
    new MutationObserver(records => {
      records.forEach(record => record.addedNodes.forEach(node => {
        if (node.nodeType !== 1 || node.closest('[data-eu-variant-bound]')) return;
        if (node.matches('[data-eu-collection-product]') || node.querySelector('[data-eu-collection-product]')) setupProductVariants(node);
      }));
    }).observe(collection, {childList: true, subtree: true});
  });

})();
